// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"a482a6fb","249":"250b5e1c","352":"9ad60a11","401":"e7eef49f","630":"8a3e2c60","726":"430f844d"}[chunkId] + ".chunk.css";
};